<ul>
    <li class="header">
        <div class="version">{{'admin.template.version' | translate}}</div>
        <div class="user">{{'admin.template.checkedOutBy' | translate}}</div>
        <div class="checkedOut">{{'admin.template.checkedOutAt' | translate}}</div>
        <div class="checkedIn">{{'admin.template.checkedInAt' | translate}}</div>
        <div class="size">{{'admin.template.size' | translate}}</div>
        <div class="filename">{{'admin.template.filename' | translate}}</div>

    </li>
    <li c-template-draft="draft" ng-repeat="draft in vm.drafts"></li>
</ul>